import { CellProps } from 'react-table';
import { ApplicationsTableRow } from '../common/types/types';
import { DropdownMenu, Icon } from 'legacy-components/componets';
import { DropdownMenuItem } from 'legacy-components/dropdown-menu/common/types/dropdown-menu-item';
import { ApplicationsPayloadCell } from '../common/types/applications-table-row';

import Dropdown from 'rc-dropdown';
import { isNewStatus, isRequestBackgroundCheckAvailable, rejectAvailable } from '../common/helpers/offer-status-actions';
import { useUnverifiedProfileActionGuard } from 'hooks/use-unverified-profile-guard';

const OffersActionsMenuCell = ({ value }: CellProps<ApplicationsTableRow, ApplicationsPayloadCell>) => {
  const { actions, status } = value;
  
  const { withActionGuard } = useUnverifiedProfileActionGuard({
    modalProps: {
      actionText: 'to perform this action',
      onClose: () => {}
    }
  });

  const menuItems: DropdownMenuItem[] = [
    actions?.onViewFullOffer && {
      id: 1,
      title: 'View full offer / background check',
      onClick: () => (actions.onViewFullOffer ? actions.onViewFullOffer() : null),
      icon: 'file',
    },
    isNewStatus(status) && {
      id: 2,
      title: 'Accept Pre-application',
      onClick: () => withActionGuard(() => actions.onAccept()),
      icon: 'circle-checked-regular',
    },
    rejectAvailable(status) && {
      id: 3,
      title: 'Reject',
      onClick: () => withActionGuard(() => actions.onReject()),
      icon: 'times-circle',
    },
    isRequestBackgroundCheckAvailable(status) && {
      id: 4,
      title: 'Request background check',
      onClick: () => withActionGuard(() => actions.onRequestBackgroundCheck()),
      icon: 'faEye',
    },
  ].filter(Boolean) as DropdownMenuItem[];

  return (
    <Dropdown trigger={['click']} overlay={<DropdownMenu menuItems={menuItems} headerTitle={'Offers'} />}>
      <Icon name={'dots-menu'} onClick={() => {}} />
    </Dropdown>
  );
};

export { OffersActionsMenuCell };
